<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.adaugaContact')}} </h4>
        </div>
        <form class="add-user-form" id="add-contact">
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group"
                         v-for="input_field in input_fields.column_1"
                         :key="input_field.id">
                          <input type="text" class="form-control"
                                 placeholder=""
                                 v-validate="input_field.validationRules"
                                 :data-vv-as="input_field.labelName"
                                 v-bind:name="input_field.inputName"
                                 v-bind:id="input_field.inputName">
                          <label class=""> {{input_field.labelName}} </label>
                          <span class="focus-input"></span>
                          <span class="symbol-input">
                              <i v-bind:class="input_field.icon"></i>
                          </span>
                          <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group" v-for="input_field in input_fields.column_2" :key="input_field.id">
                        <input type="text"
                               class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :data-vv-as="input_field.labelName"
                               :name="input_field.inputName"
                               :id="input_field.inputName">
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                            <span class="symbol-input">
                            <i v-bind:class="input_field.icon"></i>
                        </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('placeholder.notite')}} </h4>
                    </div>
                    <div class="inner-location-group">
                        <textarea :placeholder="$t('placeholder.notite')" name='notes'></textarea>
                        <div class="save-contact-buttons">
                            <button @click.prevent='addContact()' :disabled="this.$store.state.loading">
                                <i class="fas fa-check"></i>
                                {{$t('placeholder.salveaza')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import ContactsService from '../../api-services/contacts.service.js'
export default {
  name: 'AddContact',
  data () {
    return {
      input_fields: {
        column_1: [
          {
            inputName: 'name',
            labelName: this.$t('placeholder.nume'),
            icon: 'fas fa-user',
            validationRules: ''
          },
          {
            inputName: 'company_name',
            labelName: this.$t('placeholder.numeCompanie'),
            icon: 'fas fa-building',
            validationRules: ''
          },
          {
            inputName: 'function',
            labelName: this.$t('placeholder.functie'),
            icon: 'fas fa-user-tie',
            validationRules: ''
          }
        ],
        column_2: [
          {
            inputName: 'phone',
            labelName: this.$t('placeholder.telefon'),
            icon: 'fas fa-phone',
            validationRules: 'numeric'
          },
          {
            inputName: 'email',
            labelName: this.$t('placeholder.email'),
            icon: 'fas fa-envelope',
            validationRules: 'email'
          }
        ]
      }
    }
  },
  methods: {
    addContact () {
      this.$store.dispatch('showLoading')
      // this.adjustLoadingContainer()
      let formData = new FormData(document.getElementById('add-contact'))
      ContactsService.create(formData)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          if (response.status === 201) {
            this.$notify({
              group: 'succes',
              type: 'success',
              // title: 'Added',
              text: this.$t('success.contactAdaugat'),
              'animation-type': 'css'
            })
            // var frm = document.getElementById('test-id')
            // alert(frm.offsetTop)
            window.scrollTo(0, 0)
            this.$router.push({ name: 'contacts' })
          }
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          if (error.response && typeof error.response.data.error === 'object') {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: this.$t('errors.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) continue
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
        })
    }
  },
  computed: {},
  created () {
    this.$store.dispatch('hideLoading')
  }
}
</script>
